import { UIStore } from "@intrasync/stores/features";
import { SettingsStore } from "@intrasync/stores";
import { ServiceViewStore } from "@intrasync/react";

// Import store lists from each view group
import estimatingStoresList from "./views/estimating/estimatingStoresList";

const appStores = [
  // Core stores
  { name: "uiStore", store: UIStore },
  { name: "settingsStore", store: SettingsStore },
  { name: "serviceViewStore", store: ServiceViewStore },

  // View group stores
  ...estimatingStoresList,
];

export default appStores;
